export const cities = [
  {
    cityAr: 'القاهرة',
    cityEn: 'Cairo'
  },
  {
    cityAr: 'الاسكندرية',
    cityEn: 'Alexandria'
  },
  {
    cityAr: 'بورسعيد',
    cityEn: 'Portsaid'
  },
  {
    cityAr: 'السويس',
    cityEn: 'Suez'
  },
  {
    cityAr: 'دمياط',
    cityEn: 'Damietta'
  },
  {
    cityAr: 'الدقهلية',
    cityEn: 'Dakahlia'
  },
  {
    cityAr: 'الشرقية',
    cityEn: 'Sharkia'
  },
  {
    cityAr: 'القليوبية',
    cityEn: 'Qaliubiya'
  },
  {
    cityAr: 'كفرالشيخ',
    cityEn: 'Kafr Al sheikh'
  },
  {
    cityAr: 'الغربية',
    cityEn: 'Gharbiya'
  },
  {
    cityAr: ' المنوفية',
    cityEn: 'Monofia'
  },
  {
    cityAr: 'البحيرة',
    cityEn: 'Beheira'
  },
  {
    cityAr: ' الإسماعلية',
    cityEn: ''
  },
  {
    cityAr: 'الجيزة',
    cityEn: 'Giza'
  },
  {
    cityAr: 'بنى سويف',
    cityEn: 'Beni Suef'
  },
  {
    cityAr: 'الفيوم',
    cityEn: 'Fayoum'
  },
  {
    cityAr: 'المنيا',
    cityEn: 'Minya'
  },
  {
    cityAr: 'أسيوط',
    cityEn: 'Assiut'
  },
  {
    cityAr: 'سوهاج',
    cityEn: 'Sohag'
  },
  {
    cityAr: 'قنا',
    cityEn: 'Qena'
  },
  {
    cityAr: 'أسوان',
    cityEn: 'Aswan'
  },
  {
    cityAr: 'البحر الأحمر',
    cityEn: 'Red Sea'
  },
  {
    cityAr: 'الأقصر',
    cityEn: 'Luxor'
  },
  {
    cityAr: 'مطروح',
    cityEn: 'Matruh'
  },
  {
    cityAr: 'شمال سيناء',
    cityEn: 'North Sinai'
  },
  {
    cityAr: 'جنوب سيناء',
    cityEn: 'South Sinai'
  },
  {
    cityAr: 'المنصوره',
    cityEn: 'Mansoura'
  },
  {
    cityAr: 'السودان',
    cityEn: 'Sudan'
  }
]